export const en = {
  badge: 'New',
  message: 'Add your Working Circle for more personalized SenSai coaching.',
  cta: 'Set Up My Circle',
  dismiss: 'Not now',
}

export const es = en
